// extracted by mini-css-extract-plugin
export default {"Container":"Member_Container__0clT3","Text":"Member_Text__kFAr0"};